import { NgModule } from '@angular/core';
import { BasketComponent } from '@app/shared/components/basket/basket.component';
import { BasketChargesComponent } from '@app/shared/components/basket/components/basket-charges/basket-charges.component';
import { BasketProductItemComponent } from '@app/shared/components/basket/components/basket-product-item/basket-product-item.component';
import { BasketDealItemComponent } from '@app/shared/components/basket/components/basket-deal-item/basket-deal-item.component';
import { CurrencyPipe } from '@angular/common';

@NgModule({
  exports: [BasketComponent, BasketDealItemComponent, BasketProductItemComponent, BasketChargesComponent],
  imports: [BasketChargesComponent, BasketDealItemComponent, BasketProductItemComponent, BasketComponent],
  providers: [CurrencyPipe]
})
export class BasketModule {}
